<div class="modal-wrap">
  <div class="top">
    <h1>푸시 전송</h1>
    <p class="sub mt-4">내용</p>
    <textarea [(ngModel)]="content" name="" id="" cols="30" rows="20" placeholder="내용을 입력해주세요."></textarea>
  </div>

  <div class="btn-wrap">
    <button (click)="modalClose()" type="button" class="btn btn-outline-light mr-2">닫기</button>
    <button (click)="sendPush()" type="button" class="btn btn-primary">전송</button>
  </div>
</div>
